<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.state" size="small" style="width: 120px;" placeholder="状态">
                        <el-option value="-1" label="全部"></el-option>
                        <el-option value="4" label="预审核"></el-option>
                        <el-option value="1" label="审核成功"></el-option>
                        <el-option value="3" label="未认证"></el-option>
                    </el-select>
                    <el-input size="small"
                              placeholder="请输入姓名"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px"
                              v-model="query.doctorName">
                    </el-input>
                    <el-input size="small" placeholder="请输入医生手机号"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px"
                              v-model="query.phoneNumber">
                    </el-input>
                    <el-input size="small" placeholder="请输入业务员"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px"
                              v-model="query.marketName">
                    </el-input>
                    <el-button type="primary" @click="search" style="width: 68px">查询</el-button>
                </div>
                
            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column width="80px" prop="doctor.realName" label="姓名"></el-table-column>
                <el-table-column width="120px" prop="doctor.phoneNumber" label="电话"></el-table-column>
                <el-table-column width="50px" label="性别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.doctor.sex === 1">男</span>
                            <span v-else-if="scope.row.doctor.sex === null">未知</span>
                            <span v-else>女</span>
                        </template>
                </el-table-column>
                <el-table-column width="50px" prop="doctor.age" label="年龄"></el-table-column>
                <el-table-column width="50px" prop="doctor.consultingFee" label="咨询费"></el-table-column>
                <el-table-column width="50px" prop="doctor.commission" label="提成比例"></el-table-column>
                <el-table-column width="80px" prop="doctor.accountMoney" label="账户余额"></el-table-column>
                <el-table-column width="80px" prop="doctor.technicalPost" label="职称"></el-table-column>
                <el-table-column width="80px" prop="doctor.administrativeOffice" label="科室"></el-table-column>
                <el-table-column width="80px" prop="title" label="执业单位"></el-table-column>
                <el-table-column width="80px" prop="doctor.specialize" label="擅长"></el-table-column>
                <el-table-column  prop="realNameImage" label="实名照1">
                    <!--
                    <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.realNameImage)" >

                    </template>
                    -->
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.realNameImage)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.realNameImage)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.realNameImage)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 100px;" prop="realNameImage2" label="实名照2">
                    <!--
                     <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.realNameImage2)" >

                    </template>
                    -->
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.realNameImage2)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.realNameImage2)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.realNameImage2)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 120px;" prop="qualificationImage1" label="资格证书1">
                    <!--
                    <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.qualificationImage1)" >

                    </template>
                    -->
                     <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.qualificationImage1)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.qualificationImage1)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.qualificationImage1)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 120px;" prop="qualificationImage2" label="资格证书2">
                    <!--
                    <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.qualificationImage2)" >

                    </template>
                    -->
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.qualificationImage2)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.qualificationImage2)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.qualificationImage2)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 120px;" prop="chestCard" label="医院胸牌照">
                    <!--
                    <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.chestCard)" >

                    </template>
                    -->
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.chestCard)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.chestCard)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.chestCard)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 120px;" prop="westernQualificationImage" label="西学中资格证">
                    <!--
                    <template width="120px" slot-scope="scope">

                    <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.westernQualificationImage)" >

                    </template>
                    -->
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.westernQualificationImage)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.westernQualificationImage)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.westernQualificationImage)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column style="width: 100px;" prop="doctor.salesName" label="业务员姓名"></el-table-column>
                <el-table-column style="width: 100px;" prop="doctor.salesPhone" label="业务员手机号"></el-table-column>
                <el-table-column style="width: 80px;"  prop="doctor.state" label="状态">
                    <template slot-scope="scope">
                            <span v-if="scope.row.doctor.state === 1">审核成功</span>
                            <span v-else-if="scope.row.doctor.state === 0">待审核</span>
                            <span v-else-if="scope.row.doctor.state === 3">未认证</span>
                            <span v-else-if="scope.row.doctor.state === 4">预审核</span>
                            <span v-else-if="scope.row.doctor.state === 2">审核失败</span>
                    </template>
                </el-table-column>
                <el-table-column width="100px" prop="doctor.creationTime" label="注册时间" :formatter="dateFormat"></el-table-column>
                <el-table-column label="操作" width = "300px" >
                    <template slot-scope="scope" >
                        <span v-if="scope.row.doctor.state === 0">
                            <el-button type="text" @click="openAudit(scope.row)">审核</el-button>                            
                        </span>
                        <el-button type="text" @click="checkAccountLog(scope.row)">查看流水</el-button>
                        <el-button type="text" @click="lockPharmacy(scope.row)">锁定药房</el-button>
                        <el-button type="text" @click="openWithdrawal(scope.row)">提现</el-button>
                        <el-button type="text" @click="openDeduct(scope.row)">积分扣减</el-button>
                        <el-button type="text" @click="openAward(scope.row)">积分奖励</el-button>
                        <el-button type="text" @click="openAuditDetail(scope.row)">审核详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog title="流水详情" :visible.sync="dialogAccountLogVisible" width="800px" :close-on-click-modal="false">

           <div slot="title" class="header-title">
                <span class="title-name">
                    医生账户： {{ doctorAccount.phoneNumber }}

                    剩余积分：{{ doctorAccount.accountMoney }}
                    
                </span>
                
           </div>
            <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="accountQuery.state" size="small" style="width: 120px;margin-left: 20px" placeholder="类型">
                        <el-option value="" label="全部"></el-option>
                        <el-option value="0" label="收入"></el-option>
                        <el-option value="1" label="提现"></el-option>                        
                    </el-select>
                    <el-select v-model="accountQuery.message" size="small" style="width: 120px;margin-left: 20px" placeholder="收支方式">
                        <el-option value="" label="全部"></el-option>
                        <el-option value="PRESCRIPTION" label="（收入）订单积分"></el-option>
                        <el-option value="DIAGNOSE" label="（收入）诊金"></el-option>
                        <el-option value="INQUIRE" label="（收入）咨询费"></el-option>
                        <el-option value="INVITE" label="（收入）邀请好友"></el-option>
                        <el-option value="WITHDRAWAL" label="（支出）积分兑换(审核成功，已到账)"></el-option>                        
                    </el-select>
                    <el-date-picker size="small" v-model="accountQuery.startTime" type="date" placeholder="开始时间" style="width: 140px;margin-left: 20px"></el-date-picker>
                    <el-date-picker  size="small" v-model="accountQuery.endTime" type="date" placeholder="结束时间" style="width: 140px;margin-left: 20px"></el-date-picker>
                    <el-button type="primary" @click="accountSearch" style="width: 68px">查询</el-button>
                </div>
                
            </div>
            <el-table :data="accountTableData" v-loading="accountLoading">                
                <el-table-column  label="类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state === 0">收入</span>                           
                            <span v-else>提现</span>
                        </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="日期"></el-table-column>
                <el-table-column prop="money" label="金额"></el-table-column>
                <el-table-column prop="message" label="类型"></el-table-column>
                <el-table-column prop="balanceAmt" label="余额"></el-table-column>                
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="accountPageNum"
                        :page-size="accountPageSize"
                        :total="accountTotal"
                        @current-change="accountHandlePageChange"
                ></el-pagination>
            </div>
        </div>       
       
        </el-dialog>


        <el-dialog title="药房锁定" :visible.sync="dialogLockVisible" width="800px" :close-on-click-modal="false">
           
            <div style="padding: 0 20px">
     
            <el-table :data="pharmacyTableData" v-loading="pharmacyLoading">                
                
                <el-table-column prop="pharmacyName" label="药房名称"></el-table-column>
                <el-table-column prop="address" label="药房地址"></el-table-column>
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state === 1">锁定</span>                           
                        <span v-else>未锁定</span>
                    </template>
                </el-table-column>
               <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state === 1">
                            <el-button type="text" @click="unLock(scope.row)">解锁</el-button>
                        </span> 
                        <span v-else>
                            <el-button type="text" @click="lock(scope.row)">锁定</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
      
        </div>       
       
        </el-dialog>

        <el-dialog title="提现" :visible.sync="dialogWithdrawalVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="withdrawalEdit" :rules="rules" label-width="100px" size="small">
            <el-form-item label="银行名称:" prop="bankName">
                <el-input v-model="withdrawalEdit.bankName" style="width: 320px" placeholder="请输入银行名称"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号:" prop="account">
                <el-input v-model="withdrawalEdit.account" style="width: 320px" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="开户支行:" prop="openAccountBank">
                <el-input v-model="withdrawalEdit.openAccountBank" style="width: 320px" placeholder="请输入开户支行"></el-input>
            </el-form-item>
            <el-form-item label="持卡人姓名:" prop="userName">
                <el-input v-model="withdrawalEdit.userName" style="width: 320px" placeholder="请输入持卡人姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号:" prop="idCard">
                <el-input v-model="withdrawalEdit.idCard" style="width: 320px" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="提现金额:" prop="money">
                <el-input v-model="withdrawalEdit.money" style="width: 320px" placeholder="请输入提现金额"></el-input>
            </el-form-item>           
        </el-form>
        <div slot="footer" class="dialog-footer charge">
            <el-button @click="dialogWithdrawalVisible = false" style="width: 76px">取消</el-button>
            <el-button type="primary" @click="confirmWithdrawal" style="width: 76px">确定</el-button>
        </div>
    </el-dialog>

    <el-dialog title="积分扣减" :visible.sync="dialogDeductDepositVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="deductDepositEdit" label-width="100px" size="small">
            <el-form-item label="扣减金额:" prop="deductAmount">
                <el-input v-model="deductDepositEdit.deductAmount" style="width: 320px" placeholder="请输入扣减金额"></el-input>
            </el-form-item>
            <el-form-item label="备注信息:" prop="memo">
                <el-input v-model="deductDepositEdit.memo" style="width: 320px" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item label="订单编号:" prop="orderNumber">
                <el-input v-model="deductDepositEdit.orderNumber" style="width: 320px" placeholder="请输入订单编号"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer charge">
            <el-button @click="dialogDeductDepositVisible = false" style="width: 76px">取消</el-button>
            <el-button type="primary" @click="confirmDeduct" style="width: 76px">确定</el-button>
        </div>
    </el-dialog>

    <el-dialog title="积分奖励" :visible.sync="dialogAwardDepositVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="awardDepositEdit" label-width="100px" size="small">
            <el-form-item label="奖励金额:" prop="awardAmount">
                <el-input v-model="awardDepositEdit.awardAmount" style="width: 320px" placeholder="请输入奖励金额"></el-input>
            </el-form-item>
            <el-form-item label="备注信息:" prop="memo">
                <el-input v-model="awardDepositEdit.memo" style="width: 320px" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item label="奖励日期编号:" prop="awardNo">
                <el-input v-model="awardDepositEdit.awardNo" style="width: 320px" placeholder="请输入奖励日期编号"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer charge">
            <el-button @click="dialogAwardDepositVisible = false" style="width: 76px">取消</el-button>
            <el-button type="primary" @click="confirmAward" style="width: 76px">确定</el-button>
        </div>
    </el-dialog>

    <el-dialog title="审核" :visible.sync="dialogAuditVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="auditEdit" label-width="100px" size="small">
            <el-form-item label="业务员邀请码:" prop="inviteOther">
                    <el-input v-model="auditEdit.inviteOther" placeholder="请输入正确的业务员邀请码" style="width: 282px"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer charge">
        <el-button @click="dialogAuditVisible = false" style="width: 76px">取消</el-button>
        <el-button type="primary" @click="confirmPreAudit" style="width: 76px">预审核</el-button>
        <el-button type="primary" @click="confirmAudit" style="width: 76px">通过</el-button>
        <el-button type="primary" @click="refuseAudit" style="width: 76px">拒绝</el-button>
        </div>
    </el-dialog>

    <el-dialog title="审核详情" :visible.sync="dialogAuditDetailVisible" width="800px" :close-on-click-modal="false">
    
        <div style="padding: 0 20px">

        <el-table :data="auditTableData" v-loading="auditLoading">                
            
            <el-table-column prop="auditorName" label="审核人"></el-table-column>
            <el-table-column prop="doctorRoleName" label="审核后角色"></el-table-column>
            <el-table-column prop="state" label="审核后状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.state === 1">审核成功</span>
                    <span v-else-if="scope.row.state === 0">待审核</span>
                    <span v-else-if="scope.row.state === 3">未认证</span>
                    <span v-else-if="scope.row.state === 4">预审核</span>
                    <span v-else-if="scope.row.state === 2">审核失败</span>
                </template>
            </el-table-column>
           <el-table-column prop="creationTime" label="审核时间" :formatter="auditDateFormat"></el-table-column>
        </el-table>

    </div>       

 </el-dialog>
        
    </div>
</template>
<script>
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                
                // 搜索
                query: {
                    state: '-1',
                    doctorName: '',
                    phoneNumber: '',
                    marketName:''
                },
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // 列表数据
                loading: true,
                tableData: [],
                // 新增
                dialogVisible: false,
                
                // 修改
                dialogEditVisible: false,
                doctorEdit: '',

                dialogAccountLogVisible:false,
                  // 搜索
                accountQuery: {
                    userId:'',                   
                    state: '',
                    message: '',
                    startTime: '',
                    endTime:''
                },
                // 分页信息
                accountPageNum: 1,
                accountPageSize: 10,
                accountTotal: 0,
                // 列表数据
                accountLoading: true,
                accountTableData: [],
                doctorAccount:{
                    phoneNumber:'',
                    accountMoney:''
                },
                dialogLockVisible:false,
                pharmacyTableData:[],
                pharmacyLoading:true,
                doctorId:'',
                dialogWithdrawalVisible:false,
                withdrawalEdit:{
                    userId:'',
                    userState:0,
                    bankName:'',
                    account:'',
                    openAccountBank:'',
                    userName:'',
                    idCard:'',
                    money:''

                },
                rules: {
                    bankName: [{required: true, message: '请输入银行名称', trigger: 'blur'}],
                    account: [{required: true, message: '请输入银行卡号', trigger: 'blur'}],
                    openAccountBank: [{required: true, message: '请输入开户支行', trigger: 'blur'}],
                    userName: [{required: true, message: '请输入持卡人姓名', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号', trigger: 'blur'}],
                    money: [{required: true, message: '请输入提现金额', trigger: 'blur'}],
                }, 
                dialogDeductDepositVisible:false,
                deductDepositEdit:{
                    userId:'',
                    userState:0,
                    deductAmount:'',
                    memo:'',
                    orderNumber:'',         

              },
              dialogAwardDepositVisible:false,
              awardDepositEdit:{
                  userId:'',
                  userState:0,
                  awardAmount:'',
                  memo:'',
                  awardNo:''
              },
              dialogAuditVisible:false,
              auditEdit:{
                  id:'',
                  inviteOther:'',
              },
              dialogAuditDetailVisible:false,
              auditTableData:[],
              auditLoading:true



            };
        },
        created() {
            this.getData();
            
        },
        methods: {
            // 列表数据
            getData() {
                this.loading = true
                let params = {
                    state: this.query.state,
                    doctorName: this.query.doctorName,
                    phoneNumber: this.query.phoneNumber,
                    marketName: this.query.marketName,
                }
                this.axios.post('api-b/10053/100530/' + this.pageNum + '/' +this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 列表换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            search(){
                this.getData()
            },
            formatImage(imageurl) {
                let baseurl = "http://test.zgtyyy.com/chinesemedicine";                 
                return imageurl ? baseurl + imageurl : baseurl + "/static/certificate/default.png"
                
         },
         dateFormat:function(row,column){
            
            var date = new Date(row.doctor.creationTime);
            
            if(date == undefined){return ''};
            var dateTypeDate = "";
            dateTypeDate += date.getFullYear();   //年
            dateTypeDate += "-" + (date.getMonth()+1); //月
            dateTypeDate += "-" + date.getDate();  //日
            dateTypeDate += ' '
            dateTypeDate += date.getHours();
            dateTypeDate += ":"+date.getMinutes();
            dateTypeDate += ":"+date.getSeconds();
            return dateTypeDate;
        },
        checkAccountLog(data){
            this.dialogAccountLogVisible = true,
            this.doctorAccount.phoneNumber = data.doctor.phoneNumber
            this.doctorAccount.accountMoney = data.doctor.accountMoney
            this.accountQuery.userId = data.doctor.id
            this.getAccountData();
        },

        getAccountData() {
            this.accountLoading = true
            let params = {
                userId:this.accountQuery.userId,
                userState:0,
                state: this.accountQuery.state,
                message: this.accountQuery.message,
                startTime: this.accountQuery.startTime,
                endTime:this.accountQuery.endTime
            }
            this.axios.post('api-b/10053/100531/' + this.pageNum + '/' +this.pageSize,params,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    if (res.data.data.list.length !== 0) {
                        this.accountTableData = res.data.data.list
                        this.accountTotal = res.data.data.total
                    } else {
                        this.$message.info('暂无数据')
                        this.accountTableData = []
                        this.accountTotal = 0
                    }
                } else {
                    this.$message.error(res.data.message)
                    this.accountTableData = []
                    this.accountTotal = 0
                }
                this.accountLoading = false
            }).catch(() => {
                this.accountTableData = []
                this.accountTotal = 0
                this.accountLoading = false
            })
        },
        // 列表换页
        accountHandlePageChange(val) {
            this.accountPageNum = val
            this.getAccountData()
        },
        accountSearch(){
            this.getAccountData()
        },
        lockPharmacy(data){
            this.doctorId = data.doctor.id
            this.dialogLockVisible = true
            this.getLockPharmacy()

        },
        getLockPharmacy(){            
            this.axios.get('/api-b/10053/100532/'+this.doctorId,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    if (res.data.data !== null) {                        
                        this.pharmacyTableData = res.data.data
                    } else {
                        this.$message.info('暂无数据')
                        this.pharmacyTableData = []
                    }
                } else {
                    this.$message.error(res.data.message)
                    this.pharmacyTableData = []
                }
                this.pharmacyLoading = false
            })
        },
        unLock(data){
            console.log(data)
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要解锁该药房吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                
                let params = {
                    doctorId:this.doctorId,
                    pharmacyId:data.pharmacyId,  
                    state:1                     
                }
                this.axios.post('/api-b/10053/100534',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getLockPharmacy()
                    } else {
                        this.$message.error(res.data.message)
                        this.getLockPharmacy()
                    }
                }).catch(error => {})
            })

        },
        lock(data){
            console.log(data)
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要锁定该药房吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                
                let params = {
                    doctorId:this.doctorId,
                    pharmacyId:data.pharmacyId,  
                    state:1                     
                }
                this.axios.post('/api-b/10053/100533',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getLockPharmacy()
                    } else {
                        this.$message.error(res.data.message)
                        this.getLockPharmacy()
                    }
                }).catch(error => {})
            })

        },
        openWithdrawal(data){
            this.withdrawalEdit.userId = data.doctor.id
            this.dialogWithdrawalVisible = true

        },
        confirmWithdrawal(){
            let params = {
                userId: this.withdrawalEdit.userId,
                account: this.withdrawalEdit.account,
                userName:this.withdrawalEdit.userName,
                idCard: this.withdrawalEdit.idCard,
                bankName:this.withdrawalEdit.bankName,
                openAccountBank:this.withdrawalEdit.openAccountBank,                
                money:this.withdrawalEdit.money,
                userState:this.withdrawalEdit.userState
                                            
            }
            this.axios.post('api-b/10053/100535/',params,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.dialogWithdrawalVisible = false
                    this.$message.success(res.data.message)
                    this.getData()
                
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        openDeduct(data){
            this.deductDepositEdit.userId = data.doctor.id
            this.dialogDeductDepositVisible = true
        },
        confirmDeduct(){
            let params = {
                userId: this.deductDepositEdit.userId,               
                userState:this.deductDepositEdit.userState,
                deductAmount:this.deductDepositEdit.deductAmount,
                memo:this.deductDepositEdit.memo,
                orderNumber:this.deductDepositEdit.orderNumber,
                                            
            }
            this.axios.post('api-b/10053/100536/',params,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.dialogDeductDepositVisible = false
                    this.$message.success(res.data.message)
                    this.getData()
                
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        openAward(data){
            this.awardDepositEdit.userId = data.doctor.id
            this.dialogAwardDepositVisible = true
        },
        confirmAward(){
            let params = {
                userId: this.awardDepositEdit.userId,               
                userState:this.awardDepositEdit.userState,
                awardAmount:this.awardDepositEdit.awardAmount,
                memo:this.awardDepositEdit.memo,
                awardNo:this.awardDepositEdit.awardNo,
                                            
            }
            this.axios.post('api-b/10053/100537/',params,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.dialogAwardDepositVisible = false
                    this.$message.success(res.data.message)
                    this.getData()
                
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        openAudit(data){
            this.dialogAuditVisible = true
            this.auditEdit.id = data.id
            this.auditEdit.inviteOther = data.inviteOther           

        },
        confirmAudit(){
          let params = {
                id: this.auditEdit.id,               
                inviteOther:this.auditEdit.inviteOther,
                state:1                                            
            }
            audit(params)
        },
        refuseAudit(){
          let params = {
                id: this.auditEdit.id,               
                inviteOther:this.auditEdit.inviteOther,
                state:2                                           
            }
            audit(params)
        },
        audit(params){
            this.axios.post('api-b/10053/100538/',params,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.dialogAuditVisible = false
                    this.$message.success(res.data.message)
                    this.getData()
                
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        confirmPreAudit(){
            let params = {
                id: this.auditEdit.id,               
                inviteOther:this.auditEdit.inviteOther,
                state:4                                           
            }
            audit(params)

        },
        openAuditDetail(data){
            this.dialogAuditDetailVisible = true
            this.axios.get('/api-b/10053/100539/'+data.doctor.id,{
                headers:{
                    Authorization: this.authorization
                }
            }).then(res => {
                if (res.data.code === 10000) {
                    if (res.data.data !== null) {                        
                        this.auditTableData = res.data.data
                    } else {
                        this.$message.info('暂无数据')
                        this.auditTableData = []
                    }
                } else {
                    this.$message.error(res.data.message)
                    this.auditTableData = []
                }
                this.auditLoading = false
            })
        },
        auditDateFormat:function(row,column){
            
            var date = new Date(row.creationTime);
            
            if(date == undefined){return ''};
            var dateTypeDate = "";
            dateTypeDate += date.getFullYear();   //年
            dateTypeDate += "-" + (date.getMonth()+1); //月
            dateTypeDate += "-" + date.getDate();  //日
            dateTypeDate += ' '
            dateTypeDate += date.getHours();
            dateTypeDate += ":"+date.getMinutes();
            dateTypeDate += ":"+date.getSeconds();
            return dateTypeDate;
        },
           
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            }
        }
    };
    
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>